import { IMeUser } from "@krea/customer-features/types/user";

const PartnerOrganisationType = {
  REGULAR: "REGULAR",
  LENDER_LEAD_PARTNER: "LENDER_LEAD_PARTNER",
};

const RemoteIdentificationType = {
  BANK_ID: "BANK_ID",
  SMS: "SMS",
};

const hasPermission = (
  user: IMeUser | undefined,
  partnerOrganisationTypeToCheckFor: string,
  allowAdmins = true,
) => {
  let isAllowed = false;

  if (user?.isAdmin) {
    if (allowAdmins) {
      isAllowed = true;
    }
  } else if (partnerOrganisationTypeToCheckFor) {
    if (user?.partnerOrganisation?.type === partnerOrganisationTypeToCheckFor) {
      isAllowed = true;
    }
  }

  return isAllowed;
};

const leadPartnerTermsLink = (websiteUrl: string, lang: string) => {
  const links_SE = (lang: string) => {
    switch (lang) {
      case "sv":
        return "leadpartnervillkor";
      case "en":
        return "leadpartnervillkor"; // Todo: update when the English page exists
      default:
        return null;
    }
  };

  return `${websiteUrl}/${links_SE(lang)}`;
};

export {
  PartnerOrganisationType,
  RemoteIdentificationType,
  hasPermission,
  leadPartnerTermsLink,
};
